var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      attrs: { href: "" },
      on: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.onSpeakerClick.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "d-flex align-items-center",
          staticStyle: { gap: "15px" },
        },
        [
          _c("img", {
            staticClass: "rounded-circle",
            staticStyle: { "object-fit": "cover" },
            attrs: {
              width: "60",
              height: "60",
              src: _vm.speaker.profile_img_url,
            },
          }),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "font-weight-bold" }, [
              _vm._v(_vm._s(_vm.speakerFullName(_vm.speaker))),
            ]),
            _vm._v(" "),
            _vm.speaker.job_title
              ? _c("p", { staticClass: "text-muted" }, [
                  _c("small", [_vm._v(_vm._s(_vm.speaker.job_title))]),
                  _vm._v(" "),
                  _vm.isModerator
                    ? _c("small", [_c("br"), _vm._v("Moderator:in")])
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.speaker.company
              ? _c("div", [_vm._v(_vm._s(_vm.speaker.company))])
              : _vm._e(),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }